var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger"},[(_vm.mostrarBtnExcluir)?_c('i',{staticClass:"fa fa-trash fa-lg icon-button ml-2",attrs:{"title":"Excluir Feriado"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarExcluir()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }